import { render, staticRenderFns } from "./yz_ss_baoquan.vue?vue&type=template&id=82ae8626&scoped=true"
import script from "./yz_ss_baoquan.vue?vue&type=script&lang=js"
export * from "./yz_ss_baoquan.vue?vue&type=script&lang=js"
import style0 from "./yz_ss_baoquan.vue?vue&type=style&index=0&id=82ae8626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ae8626",
  null
  
)

export default component.exports